<template>
  <el-dialog
      :visible.sync="visible"
      width="calc(100% - 20px)" top="10px"
      class="edit-tender-dialog"
      :title="title" :close-on-click-modal="false"
  >
    <div class="set-bar">
      <el-popover
          placement="right"
          width="300"
          popper-class="edit-tender-popover"
          trigger="click">
        <div class="col-name-box">
          <div class="col-item" v-for="item in columnArr" :key="item.id">
            <div class="item-bar" v-if="!item.bJcol || (item.bJcol && showBJcol)">
              <div><span class="col-name">{{item.name}}</span></div>
              <div>
                <el-checkbox v-model="item.show">显示</el-checkbox>
                <el-checkbox v-model="item.fixed">冻结</el-checkbox>
              </div>
            </div>
          </div>
        </div>
        <el-button slot="reference" :size="'mini'"><i class="el-icon-setting"></i></el-button>
      </el-popover>
    </div>
    <el-table :data="showTableData" ref="tenderTable" border size="mini" empty-text="暂无物料行信息" :header-cell-style="headerCellStyle"
              :height="PAGESIZE.h-305"
    >
      <el-table-column prop="rowNo" width="50" label="行号" fixed align="left"> </el-table-column>
      <!--
        <el-table-column prop="wzCode" v-if="columnShowInfo['wzCode'].show" :fixed="columnShowInfo['wzCode'].fixed" label="物料编码" :show-overflow-tooltip="true" width="120"> </el-table-column>
       -->
      <el-table-column prop="wzName" v-if="columnShowInfo['wzName'].show" :fixed="columnShowInfo['wzName'].fixed" label="物料名称" fixed :show-overflow-tooltip="true"> </el-table-column>
      <!--
       <el-table-column prop="wzSspce" v-if="columnShowInfo['wzSspce'].show" :fixed="columnShowInfo['wzSspce'].fixed" label="询价规格" :show-overflow-tooltip="true" width="120"> </el-table-column>
       <el-table-column prop="wzModel" v-if="columnShowInfo['wzModel'].show" :fixed="columnShowInfo['wzModel'].fixed" label="询价型号" :show-overflow-tooltip="true" width="120"> </el-table-column>
       <el-table-column prop="figueNumber" v-if="columnShowInfo['figueNumber'].show" :fixed="columnShowInfo['figueNumber'].fixed" label="询价图号" :show-overflow-tooltip="true"> </el-table-column>
     -->
      <el-table-column prop="unit" v-if="columnShowInfo['unit'].show" :fixed="columnShowInfo['unit'].fixed" label="计量单位" :show-overflow-tooltip="true" width="50"> </el-table-column>
      <el-table-column prop="num" v-if="columnShowInfo['num'].show" :fixed="columnShowInfo['num'].fixed" label="询价数量" :show-overflow-tooltip="true" width="80"> </el-table-column>
      <el-table-column prop="xqDate" v-if="columnShowInfo['xqDate'].show" :fixed="columnShowInfo['xqDate'].fixed" label="需求日期" :show-overflow-tooltip="true" width="100"> </el-table-column>
      <el-table-column prop="bcExplain" v-if="columnShowInfo['bcExplain'].show" :fixed="columnShowInfo['bcExplain'].fixed" label="询价特殊备注" width="100" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column prop="rowFile" v-if="columnShowInfo['rowFile'].show" :fixed="columnShowInfo['rowFile'].fixed" label="附件" width="95">
        <template slot-scope="scope">
          <el-tag v-if="!scope.row.src && scope.row.rowNo" type="info">无附件
          </el-tag>
          <el-link v-if="scope.row.src" :underline="false" :href="baseURL+scope.row.src" target="_blank">
            <el-tag type="success">查看附件</el-tag>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="gysName" v-if="showBJcol&&columnShowInfo['gysName'].show" :fixed="columnShowInfo['gysName'].fixed" class-name="gys-col" label="供应商" :show-overflow-tooltip="true" min-width="120px"></el-table-column>
      <el-table-column prop="bjnum" v-if="showBJcol&&columnShowInfo['bjnum'].show" :fixed="columnShowInfo['bjnum'].fixed" class-name="gys-col" label="报价数量" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{  scope.row.price =='-999'?'***':scope.row.bjnum }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" v-if="showBJcol&&columnShowInfo['price'].show" :fixed="columnShowInfo['price'].fixed" label="含税单价" class-name="gys-col" width="120">
        <template slot-scope="scope">
          <span>{{  scope.row.price && scope.row.price<0?'***':scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" v-if="showBJcol&&columnShowInfo['amount'].show" :fixed="columnShowInfo['amount'].fixed" label="含税金额" class-name="gys-col" width="120">
        <template slot-scope="scope">
          <span>{{  scope.row.amount && scope.row.amount<0?'***':scope.row.amount }}</span>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="taxRate" v-if="columnShowInfo['taxRate'].show" :fixed="columnShowInfo['taxRate'].fixed" label="税率" :show-overflow-tooltip="true" :formatter="formatTaxRate" width="50"></el-table-column>
      -->
      <el-table-column prop="isFq" v-if="showBJcol&&columnShowInfo['isFq'].show" :fixed="columnShowInfo['isFq'].fixed" width="50px" class-name="gys-col" label="是否放弃" align="center">
        <template slot-scope="scope">
          <span v-if="!scope.row.hideIsFq && scope.row.isFq=='-999'">*</span>
          <span v-if="!scope.row.hideIsFq && scope.row.isFq!='-999'">{{  scope.row.isFq}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="ghZq" v-if="showBJcol&&columnShowInfo['ghZq'].show" :fixed="columnShowInfo['ghZq'].fixed" width="60px" class-name="gys-col" label="供货周期(天)">
        <template slot-scope="scope">
          <span>{{  scope.row.ghZq == '-999'?'***':scope.row.ghZq }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sameInfo" v-if="columnShowInfo['sameInfo'].show" :fixed="columnShowInfo['sameInfo'].fixed" label="询报价是否一致" :show-overflow-tooltip="true" width="80"> </el-table-column>
      <!--
        <el-table-column prop="bjExplain" v-if="showBJcol&&columnShowInfo['bjExplain'].show" :fixed="columnShowInfo['bjExplain'].fixed" width="100px" class-name="gys-col" label="付款方式">
            <template slot-scope="scope">
                <span>{{  scope.row.bjExplain == '-999'?'***':scope.row.bjExplain }}</span>
            </template>
        </el-table-column>
      -->
      <el-table-column prop="bjwlmc" v-if="showBJcol&&columnShowInfo['bjwlmc'].show" :fixed="columnShowInfo['bjwlmc'].fixed" width="100px" class-name="gys-col" label="报价物料名称">
        <template slot-scope="scope">
          <span>{{  scope.row.bjwlmc == '-999'?'***':scope.row.bjwlmc }}</span>
        </template>
      </el-table-column>
      <!--
       <el-table-column prop="bjgg" v-if="showBJcol&&columnShowInfo['bjgg'].show" :fixed="columnShowInfo['bjgg'].fixed" width="180px" class-name="gys-col" label="报价规格">
           <template slot-scope="scope">
               <span>{{  scope.row.bjgg == '-999'?'***':scope.row.bjgg }}</span>
           </template>
       </el-table-column>
       <el-table-column prop="bjxh" v-if="showBJcol&&columnShowInfo['bjxh'].show" :fixed="columnShowInfo['bjxh'].fixed" width="180px" class-name="gys-col" label="报价型号">
           <template slot-scope="scope">
               <span>{{  scope.row.bjxh == '-999'?'***':scope.row.bjxh }}</span>
           </template>
       </el-table-column>
       <el-table-column prop="bjth" v-if="showBJcol&&columnShowInfo['bjth'].show" :fixed="columnShowInfo['bjth'].fixed" width="180px" class-name="gys-col" label="报价图号">
           <template slot-scope="scope">
               <span>{{  scope.row.bjth == '-999'?'***':scope.row.bjth }}</span>
           </template>
       </el-table-column>
       <el-table-column prop="minCgl" v-if="showBJcol&&columnShowInfo['minCgl'].show" :fixed="columnShowInfo['minCgl'].fixed" width="100px" class-name="gys-col" label="最小采购量">
           <template slot-scope="scope">
               <span>{{  scope.row.minCgl == '-999'?'***':scope.row.minCgl }}</span>
           </template>
       </el-table-column>
     -->
      <el-table-column prop="manufacture" v-if="showBJcol&&columnShowInfo['manufacture'].show" :fixed="columnShowInfo['manufacture'].fixed" :show-overflow-tooltip="true" width="80px" class-name="gys-col" label="运费模式">
        <template slot-scope="scope">
          <span>{{scope.row.manufacture=='-999'?'***':scope.row.manufacture}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" v-if="showBJcol&&columnShowInfo['remark'].show" :fixed="columnShowInfo['remark'].fixed" width="100px" class-name="gys-col" label="提货油库">
        <template slot-scope="scope">
          <span>{{  scope.row.remark == '-999'?'***':scope.row.remark }}</span>
        </template>
      </el-table-column>

      <el-table-column v-if="showBJcol&&columnShowInfo['isTender'].show" :fixed="columnShowInfo['isTender'].fixed" prop="isTender" class-name="gys-col" label="是否中标">
        <template slot-scope="scope">
          <el-switch
              size="mini"
              v-model="scope.row.isTender"
              active-color="#67c23a"
              @change="isTenderChange"
              inactive-color="#999">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column v-if="showBJcol&&columnShowInfo['zbjg'].show" :fixed="columnShowInfo['zbjg'].fixed" prop="zbjg" class-name="gys-col" label="中标价格" width="140">
        <template slot-scope="scope">
          <el-input size="mini" v-if="!scope.row.hideIsTender && scope.row.isTender" :disabled="!scope.row.isTender" v-model="scope.row.zbjg" @keyup.native="fixedPriceChange(scope.row,'zbjg',scope)" class="table-edit-input">
            <template slot="append">元</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column v-if="showBJcol&&columnShowInfo['tenderNum'].show" :fixed="columnShowInfo['tenderNum'].fixed" prop="tenderNum" class-name="gys-col" label="中标数量">
        <template slot-scope="scope">
          <el-input size="mini" v-if="!scope.row.hideIsTender && scope.row.isTender" v-model="scope.row.tenderNum" :disabled="!scope.row.isTender" @keyup.native="tenderNumChange(scope.row,'tenderNum')" class="table-edit-input"/>
        </template>
      </el-table-column>
     <!--
      <el-table-column v-if="showBJcol&&columnShowInfo['kbsm'].show" :fixed="columnShowInfo['kbsm'].fixed" prop="kbsm" class-name="gys-col" label="开标说明" width="120">
        <template slot-scope="scope">
          <el-input size="mini" v-if="!scope.row.hideIsTender && scope.row.isTender" v-model="scope.row.kbsm" :disabled="!scope.row.isTender" :rows="1" type="textarea" class="table-edit-input"/>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="gysSrc" v-if="showBJcol&&columnShowInfo['gysSrc'].show" :fixed="columnShowInfo['gysSrc'].fixed" width="100px" class-name="gys-col" label="供应商附件">
        <template slot-scope="scope">
          <el-tag v-if="!scope.row.gysSrc" type="info">无附件
          </el-tag>
          <el-link v-if="scope.row.gysSrc" :underline="false" :href="baseURL+scope.row.gysSrc" target="_blank">
            <el-tag type="success">查看附件</el-tag>
          </el-link>
        </template>
      </el-table-column>

    </el-table>

    <el-form label-width="100px" size="small" style="margin-top:20px">
      <el-row >
        <el-col :span="16">
          <el-form-item label="评审意见:">
            <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 6}"
                placeholder="请输入评审意见"
                v-model="dbremark">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
            <el-button @click="footFun(1)" size="small">关 闭</el-button>
            <el-button type="primary" @click="footFun(3)" size="small">暂 存</el-button>
            <el-button type="primary" @click="footFun(2)" size="small">保 存</el-button>
        </span>
  </el-dialog>
</template>
<script>
import ret from 'bluebird/js/release/util'

export default {
  data(){
    return {
      title:'编辑中标供方',
      showTableData:[],
      visible:false,
      dbremark:'',
      columnArr:[

        {id:'wzName',prop:'wzName',name:'物料名称', fixed: true, show: true },
        {id:'unit',prop:'unit',name:'计量单位', fixed: false, show: true },
        {id:'num',prop:'num',name:'询价数量', fixed: false, show: true },
        {id:'xqDate',prop:'xqDate',name:'需求日期', fixed: false, show: true },
        {id:'bcExplain',prop:'bcExplain',name:'询价特殊备注', fixed: false, show: true },
        {id:'rowFile',prop:'rowFile',name:'附件', fixed: false, show: true },
        {id:'gysName',prop:'gysName',name:'供应商', fixed: false, show: true,bJcol:true },
        {id:'bjnum',prop:'bjnum',name:'报价数量', fixed: false, show: true,bJcol:true },
        {id:'price',prop:'price',name:'含税单价', fixed: false, show: true,bJcol:true },
        {id:'amount',prop:'amount',name:'含税金额', fixed: false, show: true,bJcol:true },
        {id:'taxRate',prop:'taxRate',name:'税率', fixed: false, show: true },
        {id:'isFq',prop:'isFq',name:'是否放弃', fixed: false, show: true,bJcol:true },
        {id:'manufacture',prop:'manufacture',name:'运费模式', fixed: false, show: true,bJcol:true },
        {id:'ghZq',prop:'ghZq',name:'供货周期', fixed: false, show: true,bJcol:true,bJcol:true },
        {id:'bjwlmc',prop:'bjwlmc',name:'报价物料名称', fixed: false, show: true,bJcol:true,bJcol:true },
        {id:'remark',prop:'remark',name:'提货油库', fixed: false, show: true,bJcol:true },
        {id:'sameInfo',prop:'sameInfo',name:'询报价是否一致', fixed: false, show: true,bJcol:true },
        {id:'isTender',prop:'isTender',name:'是否中标', fixed: false, show: true,bJcol:true },
        {id:'zbjg',prop:'zbjg',name:'中标价格', fixed: false, show: true,bJcol:true },
        {id:'tenderNum',prop:'tenderNum',name:'中标数量', fixed: false, show: true,bJcol:true },
        {id:'kbsm',prop:'kbsm',name:'开标说明', fixed: false, show: true,bJcol:true },
        {id:'gysSrc',prop:'gysSrc',name:'供应商附件', fixed: false, show: true,bJcol:true },

        //  {id:'wzCode',prop:'wzCode',name:'物料编码', fixed: true, show: true },
        //   {id:'wzSspce',prop:'wzSspce',name:'询价规格', fixed: false, show: true },
        //   {id:'wzModel',prop:'wzModel',name:'询价型号', fixed: false, show: true },
        //   {id:'figueNumber',prop:'figueNumber',name:'询价图号', fixed: false, show: true },
        //   {id:'bjExplain',prop:'bjExplain',name:'付款方式', fixed: false, show: true,bJcol:true },
        // {id:'effectivePeriod',prop:'effectivePeriod',name:'报价有效期', fixed: false, show: true,bJcol:true },
        //  {id:'bjgg',prop:'bjgg',name:'报价规格', fixed: false, show: true,bJcol:true },
        //  {id:'bjxh',prop:'bjxh',name:'报价型号', fixed: false, show: true,bJcol:true },
        //   {id:'bjth',prop:'bjth',name:'报价图号', fixed: false, show: true,bJcol:true },
        //   {id:'minCgl',prop:'minCgl',name:'最小采购量', fixed: false, show: true,bJcol:true },

      ],
    }
  },
  created(){
    let columnShowInfo = window.localStorage.getItem('TENDER_COLIMN_SHOW_INFO');
    if(columnShowInfo){
      let obj = JSON.parse(columnShowInfo)
      let arr = [...this.columnArr]
      arr.forEach((item) => {
        item.fixed = obj[item.prop].fixed;
        item.show = obj[item.prop].show;
      })
      this.columnArr = [...arr]
    }

  },
  props:['hId','orderInfo'],
  computed:{
    columnShowInfo:function(){
      let obj = {}
      this.columnArr.forEach((item)=>{
        console.log(11)
        obj[item.prop] = {
          fixed:item.fixed,
          show:item.show,
        }
      })
      return obj
    },
    PAGESIZE:function(){
      return this.$store.getters['app/sizeInfo'];
    },
    userRoles:function(){
      return this.$store.getters['user/roles'];
    },
    showBJcol:function(){
      return !this.checkRole('gys_role') && this.orderInfo.orderState>=3;      // 待定标状态
    },
  },
  methods:{
    // 限制只能输入两位小数得数字
    fixedPriceChange(row,prop,scope){
      let curVal = row[prop];
      let curRow = {...row}
      // console.log(scope.$index)
      // console.log(curVal)
      curVal = curVal.replace(/(^\s*)|(\s*$)/g, "");
      const reg = /[^\d.]/g;
      // 只能是数字和小数点，不能是其他输入
      curVal = curVal.replace(reg, "");
      // 保证第一位只能是数字，不能是点
      curVal = curVal.replace(/^\./g, "");
      // 小数只能出现1位
      curVal = curVal
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".");
      // 小数点后面保留2位
      curVal = curVal.replace( /^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      curRow[prop] = curVal;
      this.$set(this.showTableData, scope.$index, curRow);
    },
    isTenderChange(val,row){
      // console.log(val,row)
      let data = [...this.showTableData];
      data.forEach((item) => {
        // if(item.isTender && !item.chooseReason){
        //     item.chooseReason = '最低价'
        // }
        if(item.isTender && !item.zbjg){
          item.zbjg = item.price!='-999'?item.price:''
        }
        if(item.isTender && !item.tenderNum){
          item.tenderNum = item.bjOldNum
        }
      })
      this.showTableData = [...data]
      console.log(this.showTableData)
    },
    initDialog(data){
      this.infoIsSame(data)
      this.visible = true;
      this.dbremark = this.orderInfo.dingbiaoRemark || '';
      this.$nextTick(() => {
        this.showTableData = data||[];
      })
    },
    // 询报价是否一致 处理
    infoIsSame(data){
      let wl={
        figueNumber:'',
        wzName:'',
        wzSspce:'',
        wzModel:'',
        bjOldNum:''
      }
      data.forEach((row) => {
        row['sameInfo'] = '';
        if(!row.hideIsTender){  // 有报价信息的行
          let flag = true;
          let noSameArr = []
          if(row.rowNo){
            wl={...row};
          }
          if(wl.figueNumber!=row.bjth){ // 图号
            if(flag){flag = false}
            noSameArr.push(row.bjth)
          }
          if(wl.wzName!=row.bjwlmc){ // 名称
            if(flag){flag = false}
            noSameArr.push(row.bjwlmc)
          }
          if(wl.wzSspce!=row.bjgg){ // 规格
            if(flag){flag = false}
            noSameArr.push(row.bjgg)
          }
          if(wl.wzModel!=row.bjxh){ // 型号
            if(flag){flag = false}
            noSameArr.push(row.bjxh)
          }
          if(wl.bjOldNum!=row.bjnum){ // 数量
            if(flag){flag = false}
            noSameArr.push(row.bjnum)
          }
          if(!flag){
            row['sameInfo'] = `否(${noSameArr.join('\\')})`;
          }else{
            row['sameInfo'] = '是';
          }
        }
      })
    },
    formatTaxRate: function(row) {
      // console.log('row.taxRate')
      // console.log(row.taxRate)
      if(row.taxRate == '-999'){
        return '***'
      } else if(row.taxRate || row.taxRate == 0){
        return row.taxRate+'%';
      }else{
        return ''
      }
    },
    // 整数
    tenderNumChange(row,prop){
      let curVal = row[prop];
      if(curVal){
        curVal = curVal.replace(/[^\.\d]/g, '')
        curVal = curVal.replace('.', '')
      }
      row[prop] = curVal;
    },
    closeVisible(){
      this.visible = false;
      this.$nextTick(() => {
        this.showTableData = []
      })
    },
    footFun(type){
      if(type == 1){  // 关闭
        this.$emit('callback',{type:'close'});
      }
      if(type == 2){          // 保存
        this.$emit('callback',{type:'submit',data:{type:2,data:this.showTableData,dbremark:this.dbremark}});
      }
      if(type == 3){          // 暂存
        this.$emit('callback',{type:'submit',data:{type:3,data:this.showTableData,dbremark:this.dbremark}});
      }
    },
  },
  watch:{
    'columnShowInfo':function(nVal){
      window.localStorage.setItem('TENDER_COLIMN_SHOW_INFO',JSON.stringify(nVal))
      this.$nextTick(() => {
        if(this.$refs.tenderTable){
          this.$refs.tenderTable.doLayout();
        }
      });
    },
  }
}
</script>
<style lang="scss">
.edit-tender-dialog{
  .el-dialog{
    margin-bottom: 0px;
    .el-table--border {
      border: 1px solid #82848a!important;
    }
    .el-table--border .el-table__cell{
      border-right: 1px solid #82848a!important;
    }
    .set-bar{
      margin-bottom: 10px;
    }
  }
}
.edit-tender-popover{
  .col-name-box{
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    .col-item{
      padding: 2px 5px;
      &:hover{
        background: rgb(247, 249, 250);
      }
      span.col-name{
        margin-right: 10px;
      }
      .item-bar{
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
</style>
